export const TAG_SOLAR_PV = 'Solar PV';
export const TAG_BATTERY_ONLY = 'battery_only';